var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C4CDD3;}\r\n\t.st2{fill:#002B5C;}\r\n\t.st3{fill:#E21936;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.3,53.4h-0.3c-80.9,0-146.4,65.5-146.7,146.4v0.3c0,80.9,65.5,146.5,146.4,146.7h0.1h0.1l0,0 c80.9,0,146.5-65.5,146.7-146.4v-0.1v-0.1C346.7,119.2,281.2,53.5,200.3,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,199.6C349.8,117,282.7,50,200.1,50h-0.1h-0.3C117,50.2,50,117.3,50,199.9v0.2v0.1 C50.1,283,117.2,350,199.9,350.1l0,0l0,0h0.1h0.1c82.8-0.1,149.7-67.2,149.8-149.8c0-0.1,0-0.1,0-0.2S350,199.8,350,199.6  M346.7,200.2L346.7,200.2c-0.1,81-65.6,146.5-146.7,146.5l0,0h-0.1h-0.1C118.9,346.6,53.4,281,53.4,200.1v-0.3 c0.1-80.9,65.8-146.4,146.7-146.4h0.3c80.9,0.2,146.3,65.8,146.3,146.7L346.7,200.2L346.7,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151,166.7c15.3-15.3,21.6-33,21.6-33l3.4-12.4l0.8-2.9l-15.7-8.8c0,0-9.1-6.3-29.5,5.5 c-23.8,14.1-43.2,32.3-53.3,51.5c-5.6,10.6-10,23.1-12.3,37c0.7,26.5,9.1,51,23.1,71.6C85.2,237,122.1,195.2,151,166.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.6,115.2c-20.3-11.9-29.5-5.5-29.5-5.5l-15.7,8.8l0.8,2.9l3.4,12.4c0,0,6.4,17.8,21.6,33 c28.8,28.4,65.4,70,61.8,108.1c13.9-20.7,22.3-45.6,22.7-72.3c-2.3-13.5-6.7-25.4-12.1-35.8C311.7,147.5,292.3,129.3,268.6,115.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.5,92.4c53.5,6,88.7,36.3,106.8,63.3c-13.6-38.9-44.8-69.6-83.9-82.5C233.9,75.6,224.3,81,219.5,92.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.7,92.4c-4.8-11.3-14.4-16.7-23.1-19.2c-39.4,13.2-70.7,44-84.2,83.2C91.5,129.3,126.8,98.4,180.7,92.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.5,90.7L200.2,75l10.6,15.7c4.3-11.6,11-18,17.8-21.6c-9.2-2-18.7-3.1-28.3-3.1c-9.8,0-19.2,1.1-28.5,3 C178.5,72.7,185.2,79.1,189.5,90.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.8,208.1c-21.7-35.1-71.1-70.7-72.8-71.8c-1.6,1.1-50.9,36.7-72.8,71.8c-29.4,47.5-25.5,75-17.9,90.6 c18.9,17.5,42.8,29.4,69.5,33.6l11.5-162.3l9.5-9.5l0.1-0.1l0,0l0,0l0.1,0.1l9.5,9.5L221.2,332l-0.2,0.1 c26.8-4.2,50.9-16.4,69.8-34C298.5,282.6,302,255.2,272.8,208.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.7,170 200.2,160.4 200.3,344.1 221,332.2 221.2,332.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.1,123.9l-4.2,3.1l-17.5,12.8l4.6-16.7l0.8-2.9l1.5-5.6l-5-2.7l-16.5-8.9c8.2-1.8,16.7-3,25.4-3.6l4.2-0.3 l0.2-0.3l1.6-3.4l0.3-0.5l0,0l4.7-9.4l4.8,9.9l0,0l0.1,0.2l1.6,3.4l0.2,0.3l4.2,0.3c8.6,0.5,17,1.6,25.4,3.6l-16.5,8.9l-5,2.7 l1.5,5.6l0.8,2.9l4.6,16.7l-17.5-12.8l-4.2-3.1v-0.1H200.1L200.1,123.9L200.1,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.3,123.9L200.3,123.9l4.2,3.2l17.5,12.8l-4.6-16.7l-0.8-2.9l-1.5-5.6l5-2.7l16.5-8.9 c-8.2-1.8-16.7-3-25.4-3.6l-4.2-0.3l-0.2-0.3l-1.6-3.4l-0.1-0.2l-4.8-9.9l-4.7,9.4l0,0l-0.3,0.5l-1.6,3.4l-0.2,0.3l-4.2,0.3 c-8.6,0.5-17,1.6-25.4,3.6l16.5,8.9l5,2.7l-1.4,5.6l-0.8,2.9l-4.6,16.7l17.5-12.8l4.2-3.1v-0.1L200.3,123.9L200.3,123.9 L200.3,123.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWas);
export default __webpack_public_path__ + "static/media/WAS.d1accb86ac6dd8c6a3c1bdbff6caafae.svg";
export { ForwardRef as ReactComponent };